import React from "react";
import { connect } from "react-redux";
import { Button, Tooltip } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { signOut } from "redux/actions/Auth";
import { useHistory } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const initials = (name) => {
	if (!name || typeof name !== "string") return "?";
	const p = name.trim().split(/\s+/).filter(Boolean);
	if (p.length === 0) return "?";
	if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
	return (p[0][0] + p[p.length - 1][0]).toUpperCase();
};

const SideNavFooter = ({ collapsed, shellTheme, user, signOut }) => {
	const history = useHistory();
	const isLight = shellTheme === "light";

	const roleText =
		user?.role !== undefined && user?.role !== null ? String(user.role) : "";

	const onOpenAccount = () => history.push(`${APP_PREFIX_PATH}/dados-conta`);

	const userRow = (
		<div
			className={`side-nav-footer__user ${isLight ? "side-nav-footer__user--light" : "side-nav-footer__user--dark"}`}
		>
			<button
				type="button"
				className="side-nav-footer__user-main"
				onClick={onOpenAccount}
			>
				<div className="side-nav-footer__avatar">{initials(user?.name)}</div>
				{!collapsed && (
					<div className="side-nav-footer__user-text">
						<div className="side-nav-footer__user-name">
							{user?.name || "—"}
						</div>
						{roleText ? (
							<div className="side-nav-footer__user-role">{roleText}</div>
						) : null}
					</div>
				)}
			</button>
			{!collapsed ? (
				<Tooltip title="Sair">
					<Button
						type="text"
						size="small"
						icon={<LogoutOutlined />}
						onClick={() => signOut()}
						className="side-nav-footer__logout"
					/>
				</Tooltip>
			) : null}
		</div>
	);

	return (
		<div
			className={`side-nav-footer ${collapsed ? "side-nav-footer--collapsed" : ""}`}
		>
			{userRow}
		</div>
	);
};

const mapStateToProps = ({ user }) => ({
	user: { ...user },
});

export default connect(mapStateToProps, { signOut })(SideNavFooter);
